import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_AUTH_SUPABASE_URL || 'https://auth.nut.new'
const supabaseAnonKey = import.meta.env.VITE_AUTH_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inpia2NhdnhpZGp5c2xxbW5iZnV4Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDAwMDU0MjAsImV4cCI6MjA1NTU4MTQyMH0.xHKTareBFW0LW0AmYXH0vOvU3mLB3jkQGwhoNWqpnTw'

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Supabase URL and Anon Key must be defined in environment variables.");
}

const supabase = createClient(supabaseUrl, supabaseAnonKey)

export const auth = supabase.auth
export const users = supabase.from('users')
export default supabase.auth